import CMSSectionPage from "./CMSSectionPage";

export default CMSSectionPage;
